import React from "react";
import Header from "./Header";
import LocationDetails from "./LocationDetails";
import "../css/Wine.css";
import useSanityPage from "../lib/useSanityPage";

export default function Wine() {
  const { page } = useSanityPage("wine", "maynooth")

  const pdfResources = page?.pdfs?.length
    ? page.pdfs
    : [
        {
          title: "Wine by the glass",
          buttonText: "Please click here to see our wines by the glass list.",
          file: { asset: { url: "/maynooth_by_the_glass.pdf" } },
          openInNewTab: true,
        },
        {
          title: "Current wine list",
          buttonText: "Please click here to see our current wine list",
          file: { asset: { url: "/maynooth_wine.pdf" } },
          openInNewTab: true,
        },
      ]

  return (
    <>
      <Header />
      <div className="container">
        <div className="row align-items-center wine-section g-0">
          <div className="col-md-6 order-1 order-md-2 mt-3 mt-md-0 text-center text-md-start px-3 px-md-0">
            <h1 className="mb-3">{page?.title || "Some of Maynooth's Favourites"}</h1>
            <p>
              {page?.sections?.[0]?.body ||
                "At ELY Wine Store Maynooth we have great fun sourcing some LovELY wines from around the world for you. We follow the corkage model, adding €16 to the take home price of any bottle. A brilliant way to explore great wines at great value. Be brave & try something different!"}
            </p>
            {pdfResources.map((resource, index) => (
              <a
                key={`${resource.title}-${index}`}
                href={resource.file?.asset?.url || "#"}
                target={resource.openInNewTab ? "_blank" : "_self"}
                rel={resource.openInNewTab ? "noreferrer" : undefined}
              >
                <p>{resource.buttonText || "View PDF"}</p>
              </a>
            ))}
          </div>

          {/* Image block */}
          <div className="col-md-6 order-2 order-md-1 text-center d-flex justify-content-center px-3 px-md-0">
            <img
              src="/images/wine.PNG"
              className="img-fluid rounded shadow d-block"
              alt="Wine Bottles"
            />
          </div>
        </div>
      </div>
      <LocationDetails />
    </>
  );
}
